import { Injectable, isDevMode } from "@angular/core";
import { AppGlobal } from "../app.global";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class BaseService {
  url: string;

  constructor(private _global: AppGlobal, private http: HttpClient) {}

  getLang(): string {
    let lang = localStorage.getItem("lang");
    if (lang == null) {
      localStorage.setItem("lang", this._global.lang);
      lang = this._global.lang;
    } else {
      this._global.lang = lang;
    }
    return lang;
  }

  getData(
    method,
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        },
    params?:
      | HttpParams
      | {
          [param: string]: string | string[];
        }
  ): Promise<any> {
    return this.http
      .get(`${this._global.localUrl}/api/${method}`, {
        headers: headers,
        params: params,
        observe: "response"
      })
      .toPromise();
  }

  sendData(url, data): Observable<any> {
    return this.http.post(`${this._global.localUrl}/${url}`, data);
  }

  login(): Observable<any> {
    return this.sendData("api/login", {
      userName: "WebUser",
      password: "CompanySD@2019"
    });
  }

  getConnID(): string {
    return this._global.conId;
  }

  getInfoError(): { code: number; title: string; msg: string } {
    if (this.getLang() == "ar")
      return {
        code: this._global.codeError,
        title: this._global.titleErrorAr,
        msg: this._global.msgErrorAr
      };
    else
      return {
        code: this._global.codeError,
        title: this._global.titleErrorEn,
        msg: this._global.msgErrorEn
      };
  }

  setInfoError(
    code: number,
    title: { en: string; ar: string } = null,
    msg: { en: string; ar: string } = null
  ): void {
    this._global.codeError = code;
    if (title) {
      if (title.en && title.ar) {
        this._global.titleErrorEn = title.en;
        this._global.title = title.en;
      }
    }
    if (msg) {
      if (msg.en && msg.ar) {
        this._global.msgErrorEn = msg.en;
        this._global.msgErrorAr = msg.en;
      }
    }
  }

  chatStatus: boolean;

  getStatus() {}
}
